// =====================================================================
// PLENARIUM:TV_AGUARDANDO -- tela da TV antes de a sessao comecar
// Mesmo visual das telas de boas-vindas e agradecimento: azul profundo,
// detalhes em dourado, relogio grande, data por extenso, proxima sessao
// (se estiver agendada) e a galeria dos vereadores com a Mesa em destaque.
// =====================================================================
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const MESES = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
const DIAS = ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'];
const p2 = (n) => String(n).padStart(2, '0');
const ORDEM_MESA = ['PRESIDENTE', 'VICE_PRESIDENTE', 'SEGUNDO_VICE_PRESIDENTE', 'PRIMEIRO_SECRETARIO', 'SEGUNDO_SECRETARIO', 'TESOUREIRO'];
function cargo(v) {
  const f = v && v.sexo === 'F';
  switch (v && v.cargo) {
    case 'PRESIDENTE': return 'Presidente';
    case 'VICE_PRESIDENTE': return 'Vice-Presidente';
    case 'SEGUNDO_VICE_PRESIDENTE': return '2º Vice-Presidente';
    case 'PRIMEIRO_SECRETARIO': return f ? '1ª Secretária' : '1º Secretário';
    case 'SEGUNDO_SECRETARIO': return f ? '2ª Secretária' : '2º Secretário';
    case 'TESOUREIRO': return f ? 'Tesoureira' : 'Tesoureiro';
    default: return f ? 'Vereadora' : 'Vereador';
  }
}
const iniciais = (n) => String(n || '').trim().split(/\s+/).map(x => x[0]).filter(Boolean).slice(0, 2).join('').toUpperCase();

const CSS = `
.pag { position: relative; width: 100vw; height: 100vh; overflow: hidden; color: #fff; font-family: 'DM Sans', 'Inter', system-ui, sans-serif;
  background: radial-gradient(ellipse 110% 80% at 50% 0%, #163a6b 0%, #0b1f3d 45%, #050c19 100%); display: flex; flex-direction: column; }
.pag-orb { position: absolute; border-radius: 50%; filter: blur(10vh); pointer-events: none; }
.pag-orb.a { width: 70vh; height: 70vh; left: -20vh; top: -25vh; background: #1d4ed8; opacity: .38; animation: pagFlutua 18s ease-in-out infinite; }
.pag-orb.b { width: 60vh; height: 60vh; right: -18vh; top: 30vh; background: #b8862b; opacity: .16; animation: pagFlutua 22s ease-in-out infinite reverse; }
.pag-grade { position: absolute; inset: 0; pointer-events: none; opacity: .05; background-image: linear-gradient(rgba(255,255,255,.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.6) 1px, transparent 1px); background-size: 6vh 6vh; mask-image: radial-gradient(ellipse at 50% 30%, #000 20%, transparent 75%); -webkit-mask-image: radial-gradient(ellipse at 50% 30%, #000 20%, transparent 75%); }
.pag-topo { position: relative; display: flex; align-items: center; justify-content: space-between; padding: 3.6vh 5vh 0; }
.pag-marca { display: flex; align-items: center; gap: 2vh; }
.pag-marca img { height: 9vh; width: auto; max-width: 12vh; object-fit: contain; filter: drop-shadow(0 0 2.2vh rgba(245,215,142,.35)); }
.pag-marca b { display: block; font-size: 3.4vh; font-weight: 800; letter-spacing: .05vh; }
.pag-marca small { display: block; font-size: 1.6vh; font-weight: 700; letter-spacing: .6vh; text-transform: uppercase; color: #f5d78e; margin-top: .4vh; }
.pag-status { display: inline-flex; align-items: center; gap: 1.3vh; padding: 1.2vh 2.6vh; border-radius: 99px; background: rgba(255,255,255,.06); border: .18vh solid rgba(251,191,36,.45); font-size: 1.8vh; font-weight: 800; letter-spacing: .3vh; text-transform: uppercase; color: #fde68a; box-shadow: 0 0 3vh rgba(251,191,36,.12); }
.pag-status i { width: 1.3vh; height: 1.3vh; border-radius: 50%; background: #fbbf24; box-shadow: 0 0 1.4vh #fbbf24; animation: pagPulso 1.6s ease-in-out infinite; }
.pag-centro { position: relative; flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; min-height: 0; }
.pag-rot { font-size: 1.9vh; font-weight: 800; letter-spacing: .9vh; text-transform: uppercase; color: rgba(255,255,255,.55); }
.pag-hora { margin-top: 1vh; display: flex; align-items: baseline; gap: 1.4vh; font-variant-numeric: tabular-nums; line-height: 1; }
.pag-hora b { font-size: 19vh; font-weight: 900; letter-spacing: -.4vh; background: linear-gradient(180deg, #ffffff 30%, #c7d7f0 100%); -webkit-background-clip: text; background-clip: text; color: transparent; }
.pag-hora span { font-size: 6vh; font-weight: 800; color: #f5d78e; min-width: 8vh; text-align: left; }
.pag-data { margin-top: 1.6vh; font-size: 3vh; font-weight: 600; color: rgba(255,255,255,.85); }
.pag-data::first-letter { text-transform: uppercase; }
.pag-linha { width: 34vh; height: .3vh; margin: 3vh auto 2.4vh; border-radius: 99px; background: linear-gradient(90deg, transparent, #e9c46a, transparent); }
.pag-prox { font-size: 2.4vh; color: rgba(255,255,255,.7); max-width: 80vw; }
.pag-prox b { color: #f5d78e; font-weight: 800; }
.pag-prox .t { display: block; margin-top: .8vh; font-size: 2vh; color: rgba(255,255,255,.55); text-transform: uppercase; letter-spacing: .15vh; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.pag-rodape { position: relative; padding: 0 5vh 4vh; }
.pag-rodape-tit { display: flex; align-items: center; gap: 1.6vh; margin-bottom: 1.8vh; font-size: 1.7vh; font-weight: 800; letter-spacing: .5vh; text-transform: uppercase; color: rgba(255,255,255,.55); }
.pag-rodape-tit::before, .pag-rodape-tit::after { content: ''; flex: 1; height: .12vh; background: linear-gradient(90deg, transparent, rgba(255,255,255,.18), transparent); }
.pag-galeria { display: flex; gap: 1.6vh; justify-content: center; }
.pag-card { position: relative; flex: 1 1 0; min-width: 0; max-width: 21vh; aspect-ratio: 3/4.2; border-radius: 1.6vh; overflow: hidden; background: rgba(255,255,255,.05); border: .18vh solid rgba(255,255,255,.1); box-shadow: 0 1.4vh 3vh rgba(0,0,0,.35); animation: pagSobe .9s cubic-bezier(.2,.8,.2,1) both; }
.pag-card.mesa { border-color: rgba(245,215,142,.55); box-shadow: 0 1.4vh 3vh rgba(0,0,0,.35), 0 0 2.6vh rgba(233,196,106,.18); }
.pag-card img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; object-position: center 18%; }
.pag-card .sem { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; font-size: 6vh; font-weight: 900; color: rgba(255,255,255,.25); }
.pag-card .info { position: absolute; left: 0; right: 0; bottom: 0; padding: 5vh 1vh 1.3vh; background: linear-gradient(180deg, transparent 0%, rgba(5,12,25,.75) 45%, rgba(5,12,25,.96) 100%); text-align: center; }
.pag-card .info b { display: block; font-size: 1.75vh; font-weight: 800; line-height: 1.15; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.pag-card .info span { display: inline-block; max-width: 100%; box-sizing: border-box; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-top: .7vh; font-size: 1.15vh; font-weight: 800; letter-spacing: .06vh; text-transform: uppercase; padding: .35vh .9vh; border-radius: 99px; background: rgba(59,130,246,.25); color: #bfdbfe; }
.pag-card.mesa .info span { background: rgba(233,196,106,.22); color: #fde68a; }
@keyframes pagSobe { from { opacity: 0; transform: translateY(3vh) } to { opacity: 1; transform: none } }
@keyframes pagPulso { 0%,100% { opacity: 1 } 50% { opacity: .35 } }
@keyframes pagFlutua { 0%,100% { transform: translate(0,0) } 50% { transform: translate(5vh,3vh) } }
`;

function useAgora() {
  const [agora, setAgora] = useState(new Date());
  useEffect(() => { const t = setInterval(() => setAgora(new Date()), 1000); return () => clearInterval(t); }, []);
  return agora;
}

function useProximaSessao() {
  const [prox, setProx] = useState(null);
  useEffect(() => {
    let vivo = true;
    const buscar = async () => {
      try {
        const t = localStorage.getItem('token');
        const r = await axios.get('/api/sessoes', { headers: t ? { Authorization: `Bearer ${t}` } : {} });
        const agora = new Date();
        const agoraComoUTC = new Date(agora.getTime() - agora.getTimezoneOffset() * 60000); // datas gravadas como horario local "em UTC"
        const inicioDoDia = new Date(Date.UTC(agoraComoUTC.getUTCFullYear(), agoraComoUTC.getUTCMonth(), agoraComoUTC.getUTCDate()));
        const s = (Array.isArray(r.data) ? r.data : [])
          .filter(x => x.status === 'AGENDADA' && new Date(x.data) >= inicioDoDia)
          .sort((a, b) => new Date(a.data) - new Date(b.data))[0] || null;
        if (vivo) setProx(s);
      } catch (e) { /* sem a informacao, a tela segue sem ela */ }
    };
    buscar();
    const t = setInterval(buscar, 5 * 60 * 1000);
    return () => { vivo = false; clearInterval(t); };
  }, []);
  return prox;
}

function textoProxima(s) {
  const d = new Date(s.data);
  const agora = new Date();
  const hojeUTC = new Date(agora.getTime() - agora.getTimezoneOffset() * 60000);
  const mesmoDia = d.getUTCFullYear() === hojeUTC.getUTCFullYear() && d.getUTCMonth() === hojeUTC.getUTCMonth() && d.getUTCDate() === hojeUTC.getUTCDate();
  const hora = `${p2(d.getUTCHours())}h${p2(d.getUTCMinutes())}`;
  return mesmoDia ? <>Sessão prevista para <b>hoje, às {hora}</b></> : <>Próxima sessão: <b>{DIAS[d.getUTCDay()]}, {d.getUTCDate()} de {MESES[d.getUTCMonth()]}, às {hora}</b></>;
}

export default function AguardandoTV({ camara, vereadores, nomeDe, aviso }) { // PLENARIUM:AJUSTES_2110 -- aviso: acesso da TV vencido
  const agora = useAgora();
  const prox = useProximaSessao();
  const nome = (camara && camara.nome) || 'Câmara Municipal';
  const lista = [...(vereadores || [])].sort((a, b) => {
    const ia = ORDEM_MESA.indexOf(a.cargo); const ib = ORDEM_MESA.indexOf(b.cargo);
    return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib) || String(a.nome).localeCompare(String(b.nome), 'pt-BR');
  }).slice(0, 15);
  const nomeCurto = nomeDe || ((v) => v.nome);
  return (
    <div className="pag">
      <style>{CSS}</style>
      <div className="pag-orb a" /><div className="pag-orb b" /><div className="pag-grade" />
      <div className="pag-topo">
        <div className="pag-marca">
          {camara && camara.logoUrl && <img src={camara.logoUrl} alt="" />}
          <div><b>{nome}</b><small>Poder Legislativo Municipal</small></div>
        </div>
        <div className="pag-status"><i />Aguardando início da sessão</div>
      </div>

      <div className="pag-centro">
        {aviso && <div style={{ marginBottom: '3vh', maxWidth: '80vw', padding: '1.4vh 2.6vh', borderRadius: '1.4vh', background: 'rgba(239,68,68,.16)', border: '.18vh solid rgba(248,113,113,.55)', color: '#fecaca', fontSize: '2vh', fontWeight: 700 }}>{aviso}</div>}{/* PLENARIUM:AJUSTES_2110 */}
        <div className="pag-rot">Plenário</div>
        <div className="pag-hora"><b>{p2(agora.getHours())}:{p2(agora.getMinutes())}</b><span>{p2(agora.getSeconds())}</span></div>
        <div className="pag-data">{DIAS[agora.getDay()]}, {agora.getDate()} de {MESES[agora.getMonth()]} de {agora.getFullYear()}</div>
        <div className="pag-linha" />
        <div className="pag-prox">
          {prox ? textoProxima(prox) : <>Em instantes, a sessão terá início.</>}
          {prox && prox.titulo && <span className="t">{String(prox.titulo).replace(/\s+/g, ' ')}</span>}
        </div>
      </div>

      {lista.length > 0 && (
        <div className="pag-rodape">
          <div className="pag-rodape-tit">Vereadores e vereadoras</div>
          <div className="pag-galeria">
            {lista.map((v, i) => {
              const mesa = ORDEM_MESA.includes(v.cargo);
              return (
                <div key={v.id} className={`pag-card ${mesa ? 'mesa' : ''}`} style={{ animationDelay: `${0.15 + i * 0.06}s` }}>
                  {v.fotoUrl ? <img src={v.fotoUrl} alt="" /> : <div className="sem">{iniciais(nomeCurto(v))}</div>}
                  <div className="info"><b>{nomeCurto(v)}</b><span>{cargo(v)}</span></div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
